<template>
    <div class="page">
        <van-cell-group title="充值记录">
            <van-cell title="手机号" :value="record.phone"/>
            <van-cell title="充值面额" :value="record.value"/>
            <van-cell title="售价" :value="record.price"/>
            <van-cell title="下单时间" :value="record.createTime"/>
            <van-cell title="充值完成时间" :value="record.completionTime"/>
            <van-cell title="充值状态" :value="toStateLabel(record.state)"/>
            <van-cell title="充值描述" :value="record.description"/>
        </van-cell-group>
    </div>
</template>

<script>
import { Cell, CellGroup, Field, Button } from "vant";
import tradeApi from "@/api/trade";

const stateLabels = {
  untreated: "未处理",
  processing: "处理中",
  success: "成功",
  failed: "失败",
};

export default {
    name: "TradeRecord",

    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Button.name]: Button
    },

    props: {
        id: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            record: {}
        }
    },

    mounted() {
        this.load();
    },

    methods: {
        toStateLabel: function(val) {
        return stateLabels[val];
        },
        load() {
            tradeApi.get(this.id).then(res => {
                if (res.success) {
                    this.record = res.data;
                } else {
                    // ignore
                }
            })
        }
    }
}
</script>

<style scoped>
.page {

}
.actions {
    margin: 10px 10px;
}
</style>